
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buildings/[buildingName]/[buildingId]",
      function () {
        return require("private-next-pages/buildings/[buildingName]/[buildingId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buildings/[buildingName]/[buildingId]"])
      });
    }
  